import { defaultServer } from '~/api/def/servers/defaultServer';
import { BqResponse } from '~/api/def/endpoints/types';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';

export const extractionFieldEndpoint = {
  server: defaultServer,
  path: 'extraction-field',
  description: 'Extraction fields POST / GET / PATCH',
};

const ExtractionField = getExecEndpoint<ExtractionFieldEndpointDef>(
  extractionFieldEndpoint,
);

export const endpointExtractionFieldGET = async () => {
  return await ExtractionField<'GET'>({
    method: 'GET',
  });
};
export const endpointExtractionFieldPOST = async (
  payload: ExtractionFieldApiType,
) => {
  return await ExtractionField<'POST'>({
    method: 'POST',
    payload: payload,
  });
};
export const endpointExtractionFieldPATCH = async (
  payload: ExtractionFieldApiType,
  id: string,
) => {
  return await ExtractionField<'PATCH'>({
    method: 'PATCH',
    payload: payload,
    urlExtra: `/${id}`,
  });
};

export type ExtractionFieldApiType = {
  id: string;
  name: string;
  // isActive: true
};
interface ExtractionFieldEndpointDef {
  endpoint: typeof extractionFieldEndpoint;
  methods: {
    GET: {
      response: GetExtractionFieldResponse;
    };
    POST: {
      response: PostPatchExtractionFieldResponse;
      payload: ExtractionFieldApiType;
    };
    PATCH: {
      response: PostPatchExtractionFieldResponse;
      payload: ExtractionFieldApiType;
    };
  };
}
export type GetExtractionFieldResponse = BqResponse<{
  data: ExtractionFieldApiType[];
}>;
export type PostPatchExtractionFieldResponse = BqResponse<{
  data: { id: string };
}>;
